const data = {
  ret: '0',
  msg: 'success',
  data: {
    display: { tab: 1, source: 1 },
    activity: {
      totalPage: 23,
      pageSize: 10,
      currentPage: 1,
      totalCount: 222,
      list: [
        {
          planCode: 'HD11111',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD111112',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD111113',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD111114',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD111115',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD11116',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
        {
          planCode: 'HD1116',
          activityName: '测试活动-杨洪涛',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          activityVersion: 1,
        },
      ],
    },
    list: [
      {
        planCode: 'HD11111',
        activityName: '测试活动-杨洪涛',
        businessStartTime: 1608652804000,
        businessEndTime: 1608652804000,
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD111112',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD111113',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD111114',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD111115',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD11116',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
      {
        planCode: 'HD1116',
        activityName: '测试活动-杨洪涛',
        endTime: 1608652804000,
        beginTime: 1608652804000,
        activityVersion: 1,
      },
    ],
    roomActivity: {
      source: 1,
      applying: {
        totalPage: 23,
        pageSize: 10,
        currentPage: 1,
        totalCount: 222,
        list: [
          {
            activityId: '10570236',
            activityName: '测试活动-杨洪涛',
            businessStartTime: 1608652804000,
            businessEndTime: 1608652804000,
            activityType: 1,
            areaId: '14958304',
            areaName: '价格力-到手价',
            endTime: 1608652804000,
            beginTime: 1608652804000,
            applyBeginTime: 1608652804000,
            applyEndTime: 1608652804000,
            batchId: 1,
            areaRoleType: 1,
            gatherType: '1',
            cutOffTime: 2804000,
            outActivityId: 11111,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
          },
          {
            activityId: '10570239',
            activityName: '测试活动-杨洪涛',
            activityType: 1,
            areaId: '14958304',
            areaName: '价格力-到手价',
            endTime: 1608652804000,
            beginTime: 1608652804000,
            applyBeginTime: 1608652804000,
            applyEndTime: 1608652804000,
            batchId: 1,
            areaRoleType: 1,
            gatherType: '1',
            cutOffTime: 2804000,
            outActivityId: 11111,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
          },
        ],
      },
      approval: {
        totalPage: 12,
        pageSize: 10,
        currentPage: 1,
        totalCount: 111,
        list: [
          {
            activityId: '10570236',
            activityName: '测试活动-杨洪涛',
            areaId: '14958304',
            areaName: '价格力-到手价',
            endTime: 1608652804000,
            businessStartTime: 1608652804000,
            businessEndTime: 1608652804000,
            cutOffTime: 2804000,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
          },
        ],
      },
    },
    promotion: {
      source: 2,
      applying: {
        totalPage: 23,
        pageSize: 10,
        currentPage: 1,
        totalCount: 222,
        list: [
          {
            activityId: '10570236',
            activityName: '测试活动-杨洪涛',
            activityType: 1,
            areaId: '14958304',
            areaName: '价格力-到手价',
            businessStartTime: 1608652804000,
            businessEndTime: 1608652804000,
            endTime: 1608652804000,
            beginTime: 1608652804000,
            applyBeginTime: 1608652804000,
            applyEndTime: 1608652804000,
            batchId: 1,
            areaRoleType: 1,
            gatherType: '1',
            cutOffTime: 2804000,
            outActivityId: 11111,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
          },
          {
            activityId: '10570239',
            activityName: '测试活动-杨洪涛',
            activityType: 1,
            areaId: '14958304',
            areaName: '价格力-到手价',
            endTime: 1608652804000,
            beginTime: 1608652804000,
            applyBeginTime: 1608652804000,
            applyEndTime: 1608652804000,
            batchId: 1,
            areaRoleType: 1,
            gatherType: '1',
            cutOffTime: 2804000,
            outActivityId: 11111,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
          },
        ],
      },
      approval: {
        totalPage: 12,
        pageSize: 10,
        currentPage: 1,
        totalCount: 111,
        list: [
          {
            activityId: '10570236',
            activityName: '测试活动-杨洪涛',
            areaId: '14958304',
            areaName: '价格力-到手价',
            businessStartTime: 1608652804000,
            businessEndTime: 1608652804000,
            endTime: 1608652804000,
            cutOffTime: 2804000,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
            outActivityId: 11111,
          },
          {
            activityId: '1057026',
            activityName: '测试活动-杨洪涛',
            areaId: '14958304',
            areaName: '价格力-到手价',
            endTime: 1608652804000,
            cutOffTime: 2804000,
            planCode: 'HD11111',
            roomId: 'RM11111',
            activityVersion: 1,
            outActivityId: 11111,
          },
        ],
      },
    },
    applying: {
      totalPage: 23,
      pageSize: 10,
      currentPage: 1,
      totalCount: 222,
      list: [
        {
          activityId: '10570236',
          activityName: '测试活动-杨洪涛',
          activityType: 1,
          areaId: '14958304',
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          batchId: 1,
          areaRoleType: 1,
          gatherType: '1',
          cutOffTime: 2804000,
          outActivityId: 11111,
          planCode: 'HD11111',
          roomId: 'RM11111',
          activityVersion: 1,
        },
        {
          activityId: '1057023633',
          activityName: '测试活动-杨洪涛1',
          activityType: 1,
          areaId: '14958304',
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          batchId: 1,
          areaRoleType: 1,
          gatherType: '1',
          cutOffTime: 2804000,
          outActivityId: 11111,
          planCode: 'HD11111',
          roomId: 'RM11111',
          activityVersion: 1,
        },
        {
          activityId: '10570223633',
          activityName: '测试活动-杨洪涛21',
          activityType: 1,
          areaId: '14958304',
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          batchId: 1,
          areaRoleType: 1,
          gatherType: '1',
          cutOffTime: 2804000,
          outActivityId: 11111,
          planCode: 'HD11111',
          roomId: 'RM11111',
          activityVersion: 1,
        },
        {
          activityId: '1230570223633',
          activityName: '测试活动-杨洪涛121',
          activityType: 1,
          areaId: '14958304',
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          beginTime: 1608652804000,
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          batchId: 1,
          areaRoleType: 1,
          gatherType: '1',
          cutOffTime: 2804000,
          outActivityId: 11111,
          planCode: 'HD11111',
          roomId: 'RM11111',
          activityVersion: 1,
        },
      ],
    },
    approval: {
      totalPage: 12,
      pageSize: 10,
      currentPage: 1,
      totalCount: 111,
      list: [
        {
          activityId: '10570236',
          activityName: '测试活动-杨洪涛',
          areaId: '14958304',
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          cutOffTime: 2804000,
          planCode: 'HD11111',
          roomId: 'RM11111',
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          activityVersion: 1,
        },
        {
          activityId: '105702136',
          activityName: '测试活动-杨洪涛222221112',
          areaId: '14958304',
          businessStartTime: 1608652804000,
          businessEndTime: 1608652804000,
          applyBeginTime: 1608652804000,
          applyEndTime: 1608652804000,
          areaName: '价格力-到手价',
          endTime: 1608652804000,
          cutOffTime: 2804000,
          planCode: 'HD11111',
          roomId: 'RM11111',
          activityVersion: 1,
        },
      ],
    },
  },
};

export default data;
